import { render, staticRenderFns } from "./ValidMasterPhoneNumber.vue?vue&type=template&id=4f530fe4&scoped=true&"
import script from "./ValidMasterPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./ValidMasterPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./ValidMasterPhoneNumber.vue?vue&type=style&index=0&id=4f530fe4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f530fe4",
  null
  
)

export default component.exports